import PersonalInfoPage from "../components/pages/PersonalInfo";

const PersonalInfo = () => {
    return <PersonalInfoPage />;
};
export default PersonalInfo;
